"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
var GlobalClassNames = {
    root: 'ms-ResizeGroup',
};
exports.getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
    return ({
        root: [
            classNames.root,
            {
                display: 'block',
                position: 'relative'
            },
            className
        ]
    });
};
//# sourceMappingURL=ResizeGroup.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/ResizeGroup/ResizeGroup.styles.js
// module id = 1639
// module chunks = 0